module.exports = __webpack_public_path__ + "img/fractionator.3c0a5210.png";